import Copy from 'assets/img/icons/copy.svg';
import Button from 'components/_parts/atoms/button';
import CustomTable from 'components/_parts/atoms/table';
import { useState } from 'react';
import { toast } from 'react-toastify';
import styled from 'styled-components';
import { useSelector } from 'react-redux';
import LoadingCustom from 'components/layouts/loading/loading';
import { useOuterClick } from 'providers/OutsideClick';
import { OrgParameterType } from 'components/types/backOffice/company';
import ModalCustomParamOrg from '../modal';
import dataStatus from '../../customWla/list/dataStatus';

interface PropTypes {
  t: (key:string) => string
}

const customStyles = {
  headCells: {
    style: {
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      fontFamily: 'Quicksand',
      padding: '0px',
      justifyContent: 'start',
    },
  },
  cells: {
    style: {
      padding: '0px',
      justifyContent: 'start',
    },
  },
  rows: {
    style: {
      fontFamily: 'Quicksand',
      minHeight: '35px', // override the row height
      borderRadius: 0,
      filter: 'none',
      borderBottom: 'unset !important',
    },
  },
};

const ButtonMod = styled(Button)`
  width: 100%;
  width: 92px;
  height: 40px;
  float: right;
`;
const ButtonEdit = styled(Button)`
  width: 100%;
  max-width: 70px;
  height: 24px;
  float: right;
`;
const ButtonCopyID = styled(Button)`
  width: 100%;
  width: 37px;
  height: 24px;
  float: right;
  background-color: #9aff5b;
`;

const CustomTableMod = styled.div`
  [data-column-id="1"] {
    min-width: 25px;
    max-width: 50px;
    tex-align: left;
  }
  .rdt_TableBody {
    height: 500px;
    overflow: auto;
  }
`;
function Index(props : PropTypes) {
  const { t } = props;
  const [showModal, setShowModal] = useState(false);
  const [dataEdit, setDataEdit] = useState(null);
  const [typeForm, setTypeForm] = useState('');
  const [id, setId] = useState(null);
  const { keyCOP, orgParameter } = useSelector((state) => ({
    keyCOP: state?.loading?.listKey?.companyCustomOrganization,
    orgParameter: state?.company?.cop,
  }));

  const innerRef = useOuterClick((e) => {
    if (
      e?.srcElement?.className && (e.srcElement?.className === 'modal fade show'
          || e.srcElement?.className?.includes('cs_modal-bg'))
    ) {
      setShowModal(false);
      setId(null);
    }
  });

  const actionID = (id: string) => (
    <ButtonCopyID
      func={() => {
        navigator.clipboard
          .writeText(id)
          .then(() => {
            toast.success('ID Copied!');
          })
          .catch(() => {
            toast.error('ID Not Copied!');
          });
      }}
    >
      <span>
        <img src={Copy} alt="copy_id" />
      </span>
    </ButtonCopyID>
  );

  const actionEdit = (data: OrgParameterType, i: number) => (
    <ButtonEdit
      icon="edit"
      func={() => {
        setShowModal(true);
        setTypeForm('edit');
        setId(i);
        setDataEdit(data);
      }}
    >
            &nbsp;&nbsp;
      {t('org.structure_view.modal.edit')}
    </ButtonEdit>
  );

  const columns = [
    {
      name: 'No',
      sortField: true,
      selector: (_, i) => i + 1,
    },
    {
      name: 'ID',
      sortField: true,
      cell: (row) => actionID(row.company_cust_param_id),
      headerStyle: {
        padding: '0px',
        justifyContent: 'start',
      },
      style: {
        padding: '0px',
        justifyContent: 'start',
      },
      cellStyle: { verticalAlign: 'middle' },
    },
    {
      name: t('company.param_name'),
      sortField: true,
      selector: (row) => row.title,
    },
    {
      name: t('wla.status.detail.type'),
      sortField: true,
      selector: (row) => row.input_type,
      center: true,
      width: '20%',
    },
    {
      name: t('job_desc.status'),
      sortField: true,
      selector: (row) => dataStatus({ data: row.status, t }),
      center: true,
      width: '20%',
    },
    {
      name: t('org.employee.action'),
      sortField: true,
      style: {
        justifyContent: 'center',
      },
      center: true,
      selector: (row) => 'der',
      width: '15%',
      cell: (row, i) => actionEdit(row, i),
    },
  ];

  return (
    <>
      {showModal && (
      <ModalCustomParamOrg
        innerRef={innerRef}
        modal={showModal}
        funcModal={setShowModal}
        ids={id}
        data={dataEdit}
        funcId={() => setId}
        typeForm={typeForm}
        t={t}
      />
      )}
      <div
        className="tab-pane active position-relative"
        id="custom_org_list"
        role="tabpanel"
        style={{
          minHeight: '700px',
        }}
      >
        { keyCOP ? <LoadingCustom style={{ height: '100px' }} /> : (
          <>
            <div className="row">
              <div className="col-8">
                <h4 className="title">{t('company.custom_parameter')}</h4>
              </div>
              <div className="col-4">
                <ButtonMod
                  icon="create"
                  func={() => {
                    setShowModal(true);
                    setTypeForm('create');
                  }}
                >
                  &nbsp;&nbsp;
                  {t('board.add')}
                </ButtonMod>
              </div>
            </div>
            <CustomTableMod>
              <CustomTable
                columns={columns}
                data={orgParameter}
                customStyles={customStyles}
              />
            </CustomTableMod>
          </>
        ) }
      </div>
    </>
  );
}

export default Index;
